export const LOADING = "admin/products/loading";
export const ERROR = "admin/products/error";

export const GETORDERSDATA = "admin/getordersdata";
export const DELETEORDERSDATA = "admin/deleteordersdata";
export const ADDADMINPRODUCT = "admin/addadminproducts";
export const GETADMINPRODUCTS = "admin/getadminproducts";
export const EDITADMINPRODUCTS = "admin/editadminproducts";
export const DELETEADMINPRODUCTS = "admin/deleteadminproducts";
export const GETPRODUCTSCOUNT = "admin/getproductscount";
export const EDITADMINDETAILS = "admin/editadmindetails";
